import { OKTA_CONFIG } from "../services/constants";
const config = OKTA_CONFIG;

let postlogin = {
  render: async () => {
    let view = /*html*/ `
        <div id="container" class="container-fluid">
          <div class="row text-center">
            <div class="col"><h1>Validating auth tokens ...<span></h1></div>
          </div>
          <div id="token" class="hidden">
              <h2>Access Token</h2>
              <div id="access_token" class="code"></div>
          </div>
          <div id="error" class="hidden">
              <h2>Error</h2>
              <div id="error_details" class="code"></div>
          </div>
        </div>
    `;
    return view;
  },
  after_render: async () => {
    var q = parseQueryString(window.location.search.substring(1));

    // Check if the server returned an error string
    if (q.error) {
      console.error("Error returned from authorization server: " + q.error);
      document.getElementById("error_details").innerText = q.error + "\n\n" + q.error_description;
      document.getElementById("error").classList = "";
    }

    // If the server returned an authorization code, attempt to exchange it for an access token
    if (q.code) {
      // Verify state matches what we set at the beginning
      if (localStorage.getItem("pkce_state") != q.state) {
        alert("Invalid state");
      } else {
        // Exchange the authorization code for an access token
        sendPostRequest(
          config.token_endpoint,
          {
            grant_type: "authorization_code",
            code: q.code,
            client_id: config.client_id,
            redirect_uri: config.redirect_uri,
            code_verifier: localStorage.getItem("pkce_code_verifier"),
          },
          function (request, body) {
            // Initialize application now that we have an access token
            localStorage.setItem("access_token", body.access_token);
            localStorage.setItem("id_token", body.id_token);

            // Replace the history entry to remove the auth code from the browser address bar
            window.history.replaceState({}, null, "/");
            window.location = "/";
          },
          function (request, error) {
            // This could be an error response from the OAuth server, or an error because the
            // request failed such as if the OAuth server doesn't allow CORS requests
            document.getElementById("error_details").innerText = error.error + "\n\n" + error.error_description;
            document.getElementById("error").classList = "";
          }
        );
      }

      // Clean these up since we don't need them anymore
      localStorage.removeItem("pkce_state");
      localStorage.removeItem("pkce_code_verifier");
    }
  },
};

export default postlogin;

// Make a POST request and parse the response as JSON
function sendPostRequest(url, params, success, error) {
  var request = new XMLHttpRequest();
  request.open("POST", url, true);
  request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
  request.onload = function () {
    var body = {};
    try {
      body = JSON.parse(request.response);
    } catch (e) {}

    if (request.status == 200) {
      success(request, body);
    } else {
      error(request, body);
    }
  };
  request.onerror = function () {
    error(request, {});
  };
  var body = Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
  request.send(body);
}

// Parse a query string into an object
function parseQueryString(string) {
  if (string == "") {
    return {};
  }
  var segments = string.split("&").map((s) => s.split("="));
  var queryString = {};
  segments.forEach((s) => (queryString[s[0]] = s[1]));
  return queryString;
}
